<template>
  <div class="EditContainer df" :class="{ 'container-readOnly': disabled }">
    <div class="subscription">
      <a-tabs v-model:activeKey="tabType" @change="() => changeTabType()">
        <a-tab-pane :key="1" tab="Footer"></a-tab-pane>
        <a-tab-pane :key="2" tab="Checkout"></a-tab-pane>
        <a-tab-pane :key="3" tab="Register"></a-tab-pane>
        <a-tab-pane :key="4" tab="Subscribe"></a-tab-pane>
        <a-tab-pane :key="5" tab="Sidebar"></a-tab-pane>
        <a-tab-pane :key="6" tab="subscription component"></a-tab-pane>
        <a-tab-pane :key="7" tab="Payment Successful"></a-tab-pane>
      </a-tabs>
      <div v-show="tabType === 1">
        <b class="fs16 mb20">订阅</b>
        <div class="df">
          <div class="subscription-left">
            <div class="w700 mb20 df">
              <div style="flex-direction: row; display: flex;">
                <div class="mb4">默认币种：</div>
                <div
                  class="tac bg-gray"
                  style="background-color:lightgray;line-height: 26px;padding: 0 30px;"
                >
                  {{ defaultCurrency }}
                </div>
              </div>
              <div class="ml20">
                <div class="mb4 df aic">
                  <span class="mr10">展示选项：</span>
                  <a-radio-group
                    v-model:value="integratedConfig.showSubscribeOption"
                    :disabled="disabled"
                  >
                    <a-radio value="1" class="mr10">
                      展示Email订阅
                    </a-radio>
                    <a-radio value="2" class="mr10">
                      展示SMS订阅
                    </a-radio>
                    <a-radio value="3">
                      根据用户订阅状态
                    </a-radio>
                  </a-radio-group>
                </div>
              </div>
            </div>
            <div style="display: flex; flex-direction: row;">
              <div class="subscription-left">
                <div class="subscription-section">
                  <h4 class="subscription-title">Email订阅配置</h4>
                  <div class="w500 mb20">
                    <div class="mb4">Email订阅-标题：</div>
                    <a-input
                      :maxlength="50"
                      placeholder="字符限制50字符"
                      v-model:value="checkLangData.footerSubscribeTitle"
                    />
                  </div>
                  <div class="w500 mb20">
                    <div class="mb4">Email订阅-描述：</div>
                    <quillEditor
                      v-model:value="checkLangData.footerSubscribeDescription"
                      style="height: 100px; width: 500px;"
                      :options="editorOption"
                    />
                  </div>
                  <div class="w500 mb20">
                    <div class="mb4">Email订阅-输入框title文案：</div>
                    <a-input
                      :maxlength="50"
                      placeholder="字符限制50字符"
                      v-model:value="checkLangData.footerSubscribeTitleText"
                    />
                  </div>

                  <div class="w500 mb20">
                    <div class="mb4">Email订阅-输入框提示文案：</div>
                    <a-input
                      :maxlength="50"
                      placeholder="字符限制50字符"
                      v-model:value="
                        checkLangData.footerSubscribePlaceholderText
                      "
                    />
                  </div>
                  <div class="w500 mb20">
                    <div class="mb4">Email订阅-按钮文案：</div>
                    <a-input
                      v-model:value="checkLangData.footerSubscribeButtonText"
                      :maxlength="50"
                      placeholder="字符限制50字符"
                    />
                  </div>
                  <div class="w500 mb20">
                    <div class="mb4">Email订阅-订阅成功描述：</div>
                    <quillEditor
                      v-model:value="checkLangData.footerSubscribeSuccessDesc"
                      style="height: 100px; width: 500px;"
                      :options="editorOption"
                    />
                  </div>
                </div>
              </div>

              <div class="subscription-right">
                <div class="subscription-section">
                  <h4 class="subscription-title">SMS订阅配置</h4>
                  <div class="w500 mb20">
                    <div class="mb4">SMS订阅-标题：</div>
                    <a-input
                      :maxlength="50"
                      placeholder="字符限制50字符"
                      v-model:value="checkLangData.footerSmsSubscribeTitle"
                    />
                  </div>
                  <div class="w500 mb20">
                    <div class="mb4">SMS订阅-描述：</div>
                    <quillEditor
                      v-model:value="
                        checkLangData.footerSmsSubscribeDescription
                      "
                      style="height: 100px; width: 500px;"
                      :options="editorOption"
                    />
                  </div>
                  <div class="w500 mb20">
                    <div class="mb4">SMS订阅-输入框title文案：</div>
                    <a-input
                      :maxlength="50"
                      placeholder="字符限制50字符"
                      v-model:value="checkLangData.footerSmsSubscribeTitleText"
                    />
                  </div>

                  <div class="w500 mb20">
                    <div class="mb4">SMS订阅-输入框提示文案：</div>
                    <a-input
                      :maxlength="50"
                      placeholder="字符限制50字符"
                      v-model:value="
                        checkLangData.footerSmsSubscribePlaceholderText
                      "
                    />
                  </div>
                  <div class="w500 mb20">
                    <div class="mb4">SMS订阅-按钮文案：</div>
                    <a-input
                      v-model:value="checkLangData.footerSmsSubscribeButtonText"
                      :maxlength="50"
                      placeholder="字符限制50字符"
                    />
                  </div>
                  <div class="w500 mb20">
                    <div class="mb4">SMS订阅-订阅成功描述：</div>
                    <quillEditor
                      v-model:value="
                        checkLangData.footerSmsSubscribeSuccessDesc
                      "
                      style="height: 100px; width: 500px;"
                      :options="editorOption"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w500 mb20">
          <div class="mb4"><b>SEO文案</b>：</div>

          <quillEditor
            v-model:value="checkLangData.footerSeoText"
            style="height: 100px; width: 500px;"
            :options="editorOption"
          />
        </div>
        <div class="w500 mb20">
          <div class="mb4"><b>评论Icon</b>：</div>
          <a-radio-group
            v-model:value="integratedConfig.footerReviewIconType"
            class="mb4 mt4"
            :disabled="disabled"
          >
            <a-radio :value="1">自研</a-radio>
            <a-radio :value="2">Trustpilot(累计)</a-radio>
            <a-radio :value="3">Trustpilot(周度)</a-radio>
          </a-radio-group>
          <div
            class="df mt10"
            v-if="integratedConfig.footerReviewIconType === 1"
          >
            <div class="mr20">
              <div class="w120 h120 mb10 pr">
                <a-upload-dragger
                  :fileList="[]"
                  :show-upload-list="false"
                  name="file"
                  :multiple="true"
                  :customRequest="
                    e => upload(e, null, 'footerPcReviewIcon', true)
                  "
                  :accept="'.png,.jpg,.jpeg,.gif'"
                  :headers="uploadHeaders"
                >
                  <div
                    v-if="['', null].includes(checkLangData.footerPcReviewIcon)"
                  >
                    <div
                      class="w120 h120 tac"
                      style="color: #666666; font-size: 40px; line-height: 120px;"
                    >
                      <PictureOutlined />
                    </div>
                  </div>
                </a-upload-dragger>
                <div
                  v-if="!['', null].includes(checkLangData.footerPcReviewIcon)"
                  class="h120 pa l0 t0 sidebarContentBg"
                  :style="
                    `width: 120px; background: url('${checkLangData.footerPcReviewIcon}') center center/ contain no-repeat;`
                  "
                >
                  <div class="hover">
                    <EyeOutlined
                      @click="
                        () =>
                          changeVisiblePic(
                            true,
                            checkLangData.footerPcReviewIcon
                          )
                      "
                    />
                    &nbsp;&nbsp;
                    <DeleteOutlined
                      @click="checkLangData.footerPcReviewIcon = null"
                    />
                  </div>
                </div>
              </div>
              <div class="tac">PC端</div>
              <div class="tac">100 * 100</div>
            </div>
            <div>
              <div class="w120 h120 mb10 pr">
                <a-upload-dragger
                  :fileList="[]"
                  :show-upload-list="false"
                  name="file"
                  :multiple="true"
                  :customRequest="
                    e => upload(e, null, 'footerMReviewIcon', true)
                  "
                  :accept="'.png,.jpg,.jpeg,.gif'"
                  :headers="uploadHeaders"
                >
                  <div
                    v-if="['', null].includes(checkLangData.footerMReviewIcon)"
                  >
                    <div
                      class="w120 h120 tac"
                      style="color: #666666; font-size: 40px; line-height: 120px;"
                    >
                      <PictureOutlined />
                    </div>
                  </div>
                </a-upload-dragger>
                <div
                  v-if="!['', null].includes(checkLangData.footerMReviewIcon)"
                  class="h120 pa l0 t0 sidebarContentBg"
                  :style="
                    `width: 120px; background: url('${checkLangData.footerMReviewIcon}') center center/ contain no-repeat;`
                  "
                >
                  <div class="hover">
                    <EyeOutlined
                      @click="
                        () =>
                          changeVisiblePic(
                            true,
                            checkLangData.footerMReviewIcon
                          )
                      "
                    />
                    &nbsp;&nbsp;
                    <DeleteOutlined
                      @click="checkLangData.footerMReviewIcon = null"
                    />
                  </div>
                </div>
              </div>
              <div class="tac">M端</div>
              <div class="tac">72 * 72</div>
            </div>
          </div>
          <div v-else>
            <a-radio-group
              v-model:value="integratedConfig.footerReviewIconTextEnable"
              :disabled="disabled"
              @change="changeIconText"
            >
              <a-radio :style="radioStyle" :value="true">展示文案 </a-radio>
              <a-radio :style="radioStyle" :value="false">不展示文案</a-radio>
            </a-radio-group>
            <a-input
              v-if="integratedConfig.footerReviewIconTextEnable"
              v-model:value="checkLangData.footerReviewIconText"
              class="mt10 iconerror"
              placeholder="请输入"
            ></a-input>
            <div
              v-if="
                integratedConfig.footerReviewIconTextEnable &&
                  !checkLangData.footerReviewIconText
              "
              class="iconerror"
              style="color: red"
            >
              请输入展示文案
            </div>
          </div>
        </div>
        <div class="w500 mb20">
          <div class="mb4"><b>URL</b>：</div>
          <a-input
            class="w500 public-lang"
            v-model:value="integratedConfig.footerReviewIconUrl"
            placeholder="请输入"
            :disabled="disabled"
          />
        </div>
        <div class="w500 mb20">
          <div class="mb4"><b>版本信息</b>：</div>
          <quillEditor
            class="public-lang"
            v-model:value="checkLangData.footerVersionInfo"
            style="height: 100px; width: 500px;"
            :options="editorOption"
          />
        </div>
        <div class="w620 mb20">
          <div class="mb4"><b>物流Icon</b></div>
          <div class="mb4">标题：</div>
          <div>
            <div>
              <a-input
                class="w500"
                v-model:value="checkLangData.footerTransportTitle"
                :maxlength="50"
                placeholder="字符限制50字符"
              />
              <a-button :disabled="disabled" type="link">+ 添加Icon</a-button>
            </div>
          </div>
        </div>
        <div
          v-for="(item, key) in integratedConfig.footerTransportIconList"
          :key="key"
          :class="{ df: true, disabled: disabled }"
        >
          <div class="w160 mb20">
            <div class="mb4">
              Icon图片：<span style="color: #999999;">（80*24）</span>
            </div>
            <div class="df">
              <div class="mr20">
                <div class="w120 h120 mb10 pr">
                  <a-upload-dragger
                    :disabled="disabled"
                    :fileList="[]"
                    :show-upload-list="false"
                    name="file"
                    :multiple="true"
                    :customRequest="
                      e => upload(e, key, 'footerTransportIconList')
                    "
                    :accept="'.png,.jpg,.jpeg,.gif'"
                    :headers="uploadHeaders"
                  >
                    <div v-if="['', null].includes(item.imgUrl)">
                      <div
                        class="w120 h120 tac"
                        style="color: #666666; font-size: 40px; line-height: 120px;"
                      >
                        <PictureOutlined />
                      </div>
                    </div>
                  </a-upload-dragger>
                  <div
                    v-if="!['', null].includes(item.imgUrl)"
                    class="h120 pa l0 t0 sidebarContentBg"
                    :style="
                      `width: 120px; background: url('${item.imgUrl}') center center/ contain no-repeat;`
                    "
                  >
                    <div class="hover">
                      <EyeOutlined
                        @click="() => changeVisiblePic(true, item.imgUrl)"
                      />
                      &nbsp;&nbsp;
                      <DeleteOutlined @click="item.imgUrl = null" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w400 mb20">
            <div class="mb4">URL：</div>
            <a-input
              class="w300"
              v-model:value="item.link"
              placeholder="请输入"
            />
            <a-button
              type="link"
              @click="
                () => integratedConfig.footerTransportIconList.splice(key, 1)
              "
              danger
              >删除</a-button
            >
          </div>
        </div>
        <div class="w620 mb20">
          <div class="mb4"><b>支付Icon</b></div>
          <div class="mb4">标题：</div>
          <div>
            <a-input
              class="w500"
              v-model:value="checkLangData.footerPayTitle"
              :maxlength="50"
              placeholder="字符限制50字符"
            />
            <a-button
              :disabled="disabled"
              type="link"
              @click="() => addIcon('footerPayIconList')"
              >+ 添加Icon</a-button
            >
          </div>
        </div>
        <div
          v-for="(item, key) in integratedConfig.footerPayIconList"
          :key="key"
          :class="{ df: true, pubilc: true, disabled: disabled }"
        >
          <div class="w160 mb20">
            <div class="mb4">
              Icon图片：<span style="color: #999999;">（38*24）</span>
            </div>
            <div class="df">
              <div class="mr20">
                <div class="w120 h120 mb10 pr">
                  <a-upload-dragger
                    :disabled="disabled"
                    :fileList="[]"
                    :show-upload-list="false"
                    name="file"
                    :multiple="true"
                    :customRequest="e => upload(e, key, 'footerPayIconList')"
                    :accept="'.png,.jpg,.jpeg,.gif'"
                    :headers="uploadHeaders"
                  >
                    <div v-if="['', null].includes(item.imgUrl)">
                      <div
                        class="w120 h120 tac"
                        style="color: #666666; font-size: 40px; line-height: 120px;"
                      >
                        <PictureOutlined />
                      </div>
                    </div>
                  </a-upload-dragger>
                  <div
                    v-if="!['', null].includes(item.imgUrl)"
                    class="h120 pa l0 t0 sidebarContentBg"
                    :style="
                      `width: 120px; background: url('${item.imgUrl}') center center/ contain no-repeat;`
                    "
                  >
                    <div class="hover">
                      <EyeOutlined
                        @click="() => changeVisiblePic(true, item.imgUrl)"
                      />
                      &nbsp;&nbsp;
                      <DeleteOutlined @click="item.imgUrl = null" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="w400 mb20">
            <div class="mb4">URL：</div>
            <a-input
              class="w300"
              v-model:value="item.link"
              placeholder="请输入"
            />
            <a-button
              type="link"
              @click="() => integratedConfig.footerPayIconList.splice(key, 1)"
              danger
              >删除</a-button
            >
            <div class="mb4">名称：</div>
            <a-input
              class="w300"
              v-model:value="item.name"
              placeholder="请输入"
            />
          </div>
        </div>
        <div class="w500 mb20">
          <div class="mb4"><b>版权保护</b>：</div>
          <div class="mb10">icon图片</div>
          <div class="df">
            <div class="mr20">
              <div class="w120 h120 mb10 pr">
                <a-upload-dragger
                  :fileList="[]"
                  :show-upload-list="false"
                  name="file"
                  :multiple="true"
                  :customRequest="
                    e =>
                      upload(e, null, 'footerCopyrightProtectionPcIcon', true)
                  "
                  :accept="'.png,.jpg,.jpeg,.gif'"
                  :headers="uploadHeaders"
                >
                  <div
                    v-if="
                      ['', null].includes(
                        checkLangData.footerCopyrightProtectionPcIcon
                      )
                    "
                  >
                    <div
                      class="w120 h120 tac"
                      style="color: #666666; font-size: 40px; line-height: 120px;"
                    >
                      <PictureOutlined />
                    </div>
                  </div>
                </a-upload-dragger>
                <div
                  v-if="
                    !['', null].includes(
                      checkLangData.footerCopyrightProtectionPcIcon
                    )
                  "
                  class="h120 pa l0 t0 sidebarContentBg"
                  :style="
                    `width: 120px; background: url('${checkLangData.footerCopyrightProtectionPcIcon}') center center/ contain no-repeat;`
                  "
                >
                  <div class="hover">
                    <EyeOutlined
                      @click="
                        () =>
                          changeVisiblePic(
                            true,
                            checkLangData.footerCopyrightProtectionPcIcon
                          )
                      "
                    />
                    &nbsp;&nbsp;
                    <DeleteOutlined
                      @click="
                        checkLangData.footerCopyrightProtectionPcIcon = null
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="tac">PC端</div>
              <div class="tac">119 * 22</div>
            </div>
            <div>
              <div class="w120 h120 mb10 pr">
                <a-upload-dragger
                  :fileList="[]"
                  :show-upload-list="false"
                  name="file"
                  :multiple="true"
                  :customRequest="
                    e => upload(e, null, 'footerCopyrightProtectionMIcon', true)
                  "
                  :accept="'.png,.jpg,.jpeg,.gif'"
                  :headers="uploadHeaders"
                >
                  <div
                    v-if="
                      ['', null].includes(
                        checkLangData.footerCopyrightProtectionMIcon
                      )
                    "
                    URL
                  >
                    <div
                      class="w120 h120 tac"
                      style="color: #666666; font-size: 40px; line-height: 120px;"
                    >
                      <PictureOutlined />
                    </div>
                  </div>
                </a-upload-dragger>
                <div
                  v-if="
                    !['', null].includes(
                      checkLangData.footerCopyrightProtectionMIcon
                    )
                  "
                  class="h120 pa l0 t0 sidebarContentBg"
                  :style="
                    `width: 120px; background: url('${checkLangData.footerCopyrightProtectionMIcon}') center center/ contain no-repeat;`
                  "
                >
                  <div class="hover">
                    <EyeOutlined
                      @click="
                        () =>
                          changeVisiblePic(
                            true,
                            checkLangData.footerCopyrightProtectionMIcon
                          )
                      "
                    />
                    &nbsp;&nbsp;
                    <DeleteOutlined
                      @click="
                        checkLangData.footerCopyrightProtectionMIcon = null
                      "
                    />
                  </div>
                </div>
              </div>
              <div class="tac">M端</div>
              <div class="tac">98 * 18</div>
            </div>
          </div>
        </div>
        <div class="w500 mb20">
          <div class="mb4"><b>URL</b>：</div>
          <a-input
            class="w500"
            v-model:value="integratedConfig.footerCopyrightProtectionUrl"
            placeholder="请输入"
            :disabled="disabled"
          />
        </div>
        <div class="w500 mb20">
          <div class="mb4"><b>隐私条款文案</b>：</div>
          <quillEditor
            v-model:value="checkLangData.footerPrivacyPolicyText"
            style="height: 100px; width: 500px;"
            :options="editorOption"
          />
        </div>
        <div class="w500 mb20">
          <div class="mb20">
            <b>社交媒体</b
            ><span class="fs12">（最多上传10张，每张不超过50kb）</span>
          </div>
          <a-table
            :dataSource="integratedConfig.socialMediaIconList"
            :columns="columns"
            :pagination="false"
            :class="{ disabled: disabled }"
          >
            <template #imgUrl="{record, index}">
              <div class="w120 h120 mb10 pr">
                <a-upload-dragger
                  :fileList="[]"
                  :disabled="disabled"
                  :show-upload-list="false"
                  name="file"
                  :multiple="true"
                  :customRequest="e => upload(e, index, 'socialMediaIconList')"
                  :accept="'.png,.jpg,.jpeg,.gif'"
                  :headers="uploadHeaders"
                >
                  <div v-if="['', null].includes(record.imgUrl)">
                    <div
                      class="w120 h120 tac"
                      style="color: #666666; font-size: 40px; line-height: 120px;"
                    >
                      <PictureOutlined />
                    </div>
                  </div>
                  <div
                    v-if="!['', null].includes(record.imgUrl)"
                    class="h120 pa l0 t0 sidebarContentBg"
                    :style="
                      `width: 120px; background: url('${record.imgUrl}') center center/ cover no-repeat;`
                    "
                  >
                    <div class="hover">
                      <EyeOutlined
                        @click="() => changeVisiblePic(true, record.imgUrl)"
                      />
                      &nbsp;&nbsp;
                      <DeleteOutlined @click="record.imgUrl = null" />
                    </div>
                  </div>
                </a-upload-dragger>
                <div
                  v-if="!['', null].includes(record.imgUrl)"
                  class="h120 pa l0 t0 sidebarContentBg"
                  :style="
                    `width: 120px; background: url('${record.imgUrl}') center center/ contain no-repeat;`
                  "
                >
                  <div class="hover">
                    <EyeOutlined
                      @click="() => changeVisiblePic(true, record.imgUrl)"
                    />
                    &nbsp;&nbsp;
                    <DeleteOutlined @click="record.imgUrl = null" />
                  </div>
                </div>
              </div>
            </template>
            <template #link="{record}">
              <a-input
                v-model:value="record.link"
                style="width: 410px;"
                placeholder="请输入"
              />
            </template>
            <template #deal="{record, index}">
              <a-button
                v-if="!record.canDelete"
                type="link"
                @click="removeMedia(index)"
                >删除</a-button
              >
            </template>
          </a-table>
          <div
            :class="{ addMedia: true, disabled: disabled }"
            v-if="
              integratedConfig &&
                integratedConfig.socialMediaIconList &&
                integratedConfig.socialMediaIconList.length < 10
            "
            @click="() => addMedia()"
          >
            + 添加社交媒体
          </div>
        </div>
      </div>
      <div v-show="tabType === 2">
        <a-tabs v-model:activeKey="subscribeKey">
          <a-tab-pane tab="Email订阅" :key="1">
            <div class="w500 mb20">
              <div class="mb4">是否不展示订阅勾选框并默认订阅：</div>
              <a-radio-group
                :options="[
                  { value: true, label: '是' },
                  { value: false, label: '否' }
                ]"
                :disabled="disabled"
                v-model:value="integratedConfig.checkoutSubscribeDefault"
              />
            </div>
            <div
              class="w500 mb20"
              v-if="!integratedConfig.checkoutSubscribeDefault"
            >
              <div class="mb4">是否根据用户Email订阅状态展示</div>
              <a-radio-group
                :options="[
                  { value: true, label: '是' },
                  { value: false, label: '否' }
                ]"
                :disabled="disabled"
                v-model:value="integratedConfig.displayByEmail"
              />
            </div>
            <div
              class="w500 mb20"
              v-if="!integratedConfig.checkoutSubscribeDefault"
            >
              <div class="mb4"><b>勾选状态</b>：</div>
              <a-radio-group
                :disabled="disabled"
                :options="[
                  { value: 1, label: '默认勾选' },
                  { value: 2, label: '默认不勾选' }
                ]"
                v-model:value="integratedConfig.checkoutSubscribeStatus"
              />
            </div>
            <div
              class="w500 mb20"
              v-if="!integratedConfig.checkoutSubscribeDefault"
            >
              <div class="mb4"><b>订阅文案</b>：</div>
              <quillEditor
                v-model:value="checkLangData.checkoutSubscribeText"
                style="height: 100px; width: 500px;"
                :options="editorOption"
              />
            </div>
            <div class="w500 mb20">
              <div class="mb4"><b>运费险提示</b>：</div>
              <quillEditor
                v-model:value="checkLangData.checkoutFreightInsuranceTips"
                style="height: 100px; width: 500px;"
                :options="editorOption"
              />
            </div>
          </a-tab-pane>
          <a-tab-pane tab="手机订阅" :key="2">
            <!-- {{ integratedConfig }} -->
            <div class="mb20">
              <div class="mb4"><b>SMS订阅</b>：</div>
              <a-radio-group
                :disabled="disabled"
                @change="changeSubscribeType"
                :options="
                  [
                    { value: 0, label: '无' },
                    { value: 1, label: 'sms' },
                    { value: 2, label: 'whatsAPP' },
                    { value: 3, label: 'sms&WhatsApp' },
                    { value: 4, label: 'sms&WhatsApp独立订阅' }
                  ].filter(
                    item =>
                      route.query.terminalId - 0 !== 2 ||
                      [0, 3].includes(item.value)
                  )
                "
                v-model:value="
                  integratedConfig.integratedConfigPhoneSubscribe
                    .checkoutPhoneSubscribeType
                "
              />
            </div>
            <div
              class="mb20"
              v-if="
                integratedConfig.integratedConfigPhoneSubscribe
                  .checkoutPhoneSubscribeType != 0 &&
                  integratedConfig.integratedConfigPhoneSubscribe
                    .checkoutPhoneSubscribeType != 2
              "
            >
              <div class="mb4">是否根据用户sms订阅状态展示</div>
              <a-radio-group
                :options="[
                  { value: true, label: '是' },
                  { value: false, label: '否' }
                ]"
                :disabled="disabled"
                v-model:value="
                  integratedConfig.integratedConfigPhoneSubscribe.displayBySms
                "
              />
            </div>
            <div
              v-if="
                [3].includes(
                  +integratedConfig.integratedConfigPhoneSubscribe
                    .checkoutPhoneSubscribeType
                )
              "
            >
              <div class="w500 mb20">
                <div class="mb4"><b>勾选状态</b>：</div>
                <a-radio-group
                  :disabled="disabled"
                  :options="[
                    { value: 1, label: '默认勾选' },
                    { value: 2, label: '默认不勾选' }
                  ]"
                  v-model:value="
                    integratedConfig.integratedConfigPhoneSubscribe
                      .checkoutSmsSubscribeStatus
                  "
                />
              </div>
              <div class="w500 mb20">
                <div class="mb4">
                  <b>{{ descTitle }}订阅文案</b>：
                </div>
                <div
                  v-if="
                    [2].includes(route.query.terminalId - 0) &&
                      [1, 2, 3, 4].includes(
                        integratedConfig.integratedConfigPhoneSubscribe
                          .checkoutPhoneSubscribeType - 0
                      )
                  "
                >
                  <a-textarea
                    :placeholder="holder"
                    v-model:value="checkLangData.checkoutSmsSubscribeText"
                    :rows="rows"
                    autocomplete="off"
                    :auto-size="{ minRows: 2, maxRows: 5 }"
                    :disabled="disabled"
                  />
                </div>
                <div v-else>
                  <quillEditor
                    v-model:value="checkLangData.checkoutSmsSubscribeText"
                    style="height: 100px; width: 500px;"
                    :options="editorOption"
                  />
                </div>
              </div>
              <div class="w500 mb20">
                <div class="mb4">
                  <b>{{ descTitle }}订阅描述</b>：
                </div>
                <div
                  v-if="
                    [2].includes(route.query.terminalId - 0) &&
                      [1, 2, 3, 4].includes(
                        integratedConfig.integratedConfigPhoneSubscribe
                          .checkoutPhoneSubscribeType - 0
                      )
                  "
                >
                  <a-textarea
                    :placeholder="holder"
                    v-model:value="checkLangData.checkoutSmsSubscribeDesc"
                    :rows="rows"
                    autocomplete="off"
                    :auto-size="{ minRows: 2, maxRows: 5 }"
                    :disabled="disabled"
                  />
                </div>
                <div v-else>
                  <quillEditor
                    v-model:value="checkLangData.checkoutSmsSubscribeDesc"
                    style="height: 100px; width: 500px;"
                    :options="editorOption"
                  />
                </div>
              </div>
              <div class="w500 mb20">
                <div class="mb4">
                  <b>{{ descTitle }}订阅Icon</b>：<span>(52*80)</span>
                </div>
                <div class="df">
                  <div class="mr20">
                    <div class="w120 h120 mb10 pr img-readonly">
                      <a-upload-dragger
                        v-if="
                          ['', null].includes(
                            integratedConfig.integratedConfigPhoneSubscribe
                              .checkoutSmsSubscribeIcon
                          )
                        "
                        :disabled="disabled"
                        :fileList="[]"
                        :show-upload-list="false"
                        name="file"
                        :multiple="true"
                        :customRequest="
                          e => upload(e, null, 'checkoutSmsSubscribeIcon')
                        "
                        :accept="'.png,.jpg,.jpeg,.gif'"
                        :headers="uploadHeaders"
                      >
                        <div>
                          <div
                            class="w120 h120 tac"
                            style="color: #666666; font-size: 40px; line-height: 120px;"
                          >
                            <PictureOutlined />
                          </div>
                        </div>
                      </a-upload-dragger>
                      <div
                        v-else
                        class="h120 pa l0 t0 sidebarContentBg"
                        :style="
                          `width: 120px; background: url('${integratedConfig.integratedConfigPhoneSubscribe.checkoutSmsSubscribeIcon}') center center/ cover no-repeat;`
                        "
                      >
                        <div class="hover">
                          <EyeOutlined
                            @click="
                              () =>
                                changeVisiblePic(
                                  true,
                                  integratedConfig
                                    .integratedConfigPhoneSubscribe
                                    .checkoutSmsSubscribeIcon
                                )
                            "
                          />
                          &nbsp;&nbsp;
                          <DeleteOutlined
                            @click="
                              integratedConfig.integratedConfigPhoneSubscribe.checkoutSmsSubscribeIcon = null
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <a-row :gutter="24">
                <a-col
                  v-if="
                    [1, 4].includes(
                      +integratedConfig.integratedConfigPhoneSubscribe
                        .checkoutPhoneSubscribeType
                    )
                  "
                >
                  <div class="w500 mb20">
                    <div class="mb4"><b>SMS勾选状态</b>：</div>
                    <a-radio-group
                      :disabled="disabled"
                      :options="[
                        { value: 1, label: '默认勾选' },
                        { value: 2, label: '默认不勾选' }
                      ]"
                      v-model:value="
                        integratedConfig.integratedConfigPhoneSubscribe
                          .checkoutSmsSubscribeStatus
                      "
                    />
                  </div>
                  <div class="w500 mb20">
                    <div class="mb4"><b>SMS订阅文案</b>：</div>
                    <div
                      v-if="
                        [2].includes(route.query.terminalId - 0) &&
                          [1, 2, 3, 4].includes(
                            integratedConfig.integratedConfigPhoneSubscribe
                              .checkoutPhoneSubscribeType - 0
                          )
                      "
                    >
                      <a-textarea
                        :placeholder="holder"
                        v-model:value="checkLangData.checkoutSmsSubscribeText"
                        :rows="rows"
                        autocomplete="off"
                        :auto-size="{ minRows: 2, maxRows: 5 }"
                        :disabled="disabled"
                      />
                    </div>
                    <div v-else>
                      <quillEditor
                        v-model:value="checkLangData.checkoutSmsSubscribeText"
                        style="height: 100px; width: 500px;"
                        :options="editorOption"
                      />
                    </div>
                  </div>
                  <div class="w500 mb20">
                    <div class="mb4"><b>SMS订阅描述</b>：</div>
                    <div
                      v-if="
                        [2].includes(route.query.terminalId - 0) &&
                          [1, 2, 3, 4].includes(
                            integratedConfig.integratedConfigPhoneSubscribe
                              .checkoutPhoneSubscribeType - 0
                          )
                      "
                    >
                      <a-textarea
                        :placeholder="holder"
                        v-model:value="checkLangData.checkoutSmsSubscribeDesc"
                        :rows="rows"
                        autocomplete="off"
                        :auto-size="{ minRows: 2, maxRows: 5 }"
                        :disabled="disabled"
                      />
                    </div>
                    <div v-else>
                      <quillEditor
                        v-model:value="checkLangData.checkoutSmsSubscribeDesc"
                        style="height: 100px; width: 500px;"
                        :options="editorOption"
                      />
                    </div>
                  </div>
                  <div class="w500 mb20">
                    <div class="mb4">
                      <b>SMS订阅Icon</b>：<span>(52*80)</span>
                    </div>
                    <div class="df">
                      <div class="mr20">
                        <div class="w120 h120 mb10 pr img-readonly">
                          <a-upload-dragger
                            v-if="
                              ['', null].includes(
                                integratedConfig.integratedConfigPhoneSubscribe
                                  .checkoutSmsSubscribeIcon
                              )
                            "
                            :disabled="disabled"
                            :fileList="[]"
                            :show-upload-list="false"
                            name="file"
                            :multiple="true"
                            :customRequest="
                              e => upload(e, null, 'checkoutSmsSubscribeIcon')
                            "
                            :accept="'.png,.jpg,.jpeg,.gif'"
                            :headers="uploadHeaders"
                          >
                            <div>
                              <div
                                class="w120 h120 tac"
                                style="color: #666666; font-size: 40px; line-height: 120px;"
                              >
                                <PictureOutlined />
                              </div>
                            </div>
                          </a-upload-dragger>
                          <div
                            v-else
                            class="h120 pa l0 t0 sidebarContentBg"
                            :style="
                              `width: 120px; background: url('${integratedConfig.integratedConfigPhoneSubscribe.checkoutSmsSubscribeIcon}') center center/ cover no-repeat;`
                            "
                          >
                            <div class="hover">
                              <EyeOutlined
                                @click="
                                  () =>
                                    changeVisiblePic(
                                      true,
                                      integratedConfig
                                        .integratedConfigPhoneSubscribe
                                        .checkoutSmsSubscribeIcon
                                    )
                                "
                              />
                              &nbsp;&nbsp;
                              <DeleteOutlined
                                @click="
                                  integratedConfig.integratedConfigPhoneSubscribe.checkoutSmsSubscribeIcon = null
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a-col>
                <a-col
                  v-if="
                    [2, 4].includes(
                      +integratedConfig.integratedConfigPhoneSubscribe
                        .checkoutPhoneSubscribeType
                    )
                  "
                >
                  <div class="w500 mb20">
                    <div class="mb4"><b>WhatsApp勾选状态</b>：</div>
                    <a-radio-group
                      :disabled="disabled"
                      :options="[
                        { value: 1, label: '默认勾选' },
                        { value: 2, label: '默认不勾选' }
                      ]"
                      v-model:value="
                        integratedConfig.integratedConfigPhoneSubscribe
                          .checkoutWhatsappSubscribeStatus
                      "
                    />
                  </div>
                  <div class="w500 mb20">
                    <div class="mb4"><b>WhatsApp订阅文案</b>：</div>
                    <div
                      v-if="
                        [2].includes(route.query.terminalId - 0) &&
                          [1, 2, 3, 4].includes(
                            integratedConfig.integratedConfigPhoneSubscribe
                              .checkoutPhoneSubscribeType - 0
                          )
                      "
                    >
                      <a-textarea
                        :placeholder="holder"
                        v-model:value="
                          checkLangData.checkoutWhatsappSubscribeText
                        "
                        :rows="rows"
                        autocomplete="off"
                        :auto-size="{ minRows: 2, maxRows: 5 }"
                        :disabled="disabled"
                      />
                    </div>
                    <div v-else>
                      <quillEditor
                        v-model:value="
                          checkLangData.checkoutWhatsappSubscribeText
                        "
                        style="height: 100px; width: 500px;"
                        :options="editorOption"
                      />
                    </div>
                  </div>
                  <div class="w500 mb20">
                    <div class="mb4"><b>WhatsApp订阅描述</b>：</div>
                    <div
                      v-if="
                        [2].includes(route.query.terminalId - 0) &&
                          [1, 2, 3, 4].includes(
                            integratedConfig.integratedConfigPhoneSubscribe
                              .checkoutPhoneSubscribeType - 0
                          )
                      "
                    >
                      <a-textarea
                        :placeholder="holder"
                        v-model:value="
                          checkLangData.checkoutWhatsappSubscribeDesc
                        "
                        :rows="rows"
                        autocomplete="off"
                        :auto-size="{ minRows: 2, maxRows: 5 }"
                        :disabled="disabled"
                      />
                    </div>
                    <div v-else>
                      <quillEditor
                        v-model:value="
                          checkLangData.checkoutWhatsappSubscribeDesc
                        "
                        style="height: 100px; width: 500px;"
                        :options="editorOption"
                      />
                    </div>
                  </div>
                  <div class="w500 mb20">
                    <div class="mb4">
                      <b>WhatsApp订阅Icon</b>：<span>(52*80)</span>
                    </div>
                    <div class="df">
                      <div class="mr20">
                        <div class="w120 h120 mb10 pr img-readonly">
                          <a-upload-dragger
                            v-if="
                              ['', null].includes(
                                integratedConfig.integratedConfigPhoneSubscribe
                                  .checkoutWhatsappSubscribeIcon
                              )
                            "
                            :disabled="disabled"
                            :fileList="[]"
                            :show-upload-list="false"
                            name="file"
                            :multiple="true"
                            :customRequest="
                              e =>
                                upload(e, null, 'checkoutWhatsappSubscribeIcon')
                            "
                            :accept="'.png,.jpg,.jpeg,.gif'"
                            :headers="uploadHeaders"
                          >
                            <div>
                              <div
                                class="w120 h120 tac"
                                style="color: #666666; font-size: 40px; line-height: 120px;"
                              >
                                <PictureOutlined />
                              </div>
                            </div>
                          </a-upload-dragger>
                          <div
                            v-else
                            class="h120 pa l0 t0 sidebarContentBg"
                            :style="
                              `width: 120px; background: url('${integratedConfig.integratedConfigPhoneSubscribe.checkoutWhatsappSubscribeIcon}') center center/ cover no-repeat;`
                            "
                          >
                            <div class="hover">
                              <EyeOutlined
                                @click="
                                  () =>
                                    changeVisiblePic(
                                      true,
                                      integratedConfig
                                        .integratedConfigPhoneSubscribe
                                        .checkoutWhatsappSubscribeIcon
                                    )
                                "
                              />
                              &nbsp;&nbsp;
                              <DeleteOutlined
                                @click="
                                  integratedConfig.integratedConfigPhoneSubscribe.checkoutWhatsappSubscribeIcon = null
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a-col>
              </a-row>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="地址缓存" :key="3">
            <div class="w500 mb20">
              <div class="mb4"><b>地址缓存</b>：</div>
              <a-radio-group
                :disabled="disabled"
                :options="[
                  { value: 1, label: '默认勾选' },
                  { value: 2, label: '默认不勾选' }
                ]"
                v-model:value="integratedConfig.checkoutCacheAddress"
              />
            </div>
          </a-tab-pane>
        </a-tabs>
        <!-- <div><b class="fs16 mb40">Email订阅</b></div>
        <div class="df">
          <div>
            <div
              class="w500 mb20"
              v-if="!integratedConfig.checkoutSubscribeDefault"
            >
              <div class="mb4"><b>勾选状态</b>：</div>
              <a-radio-group
                :disabled="disabled"
                :options="[
                  { value: 1, label: '默认勾选' },
                  { value: 2, label: '默认不勾选' }
                ]"
                v-model:value="integratedConfig.checkoutSubscribeStatus"
              />
            </div>
            <div
              class="w500 mb20"
              v-if="!integratedConfig.checkoutSubscribeDefault"
            >
              <div class="mb4"><b>订阅文案</b>：</div>
              <quillEditor
                v-model:value="checkLangData.checkoutSubscribeText"
                style="height: 100px; width: 500px;"
                :options="editorOption"
              />
            </div>
          </div>
        </div> -->
      </div>
      <div v-show="tabType === 3">
        <div class="df">
          <div>
            <div class="w500 mb20">
              <div class="mb4"><b>隐私条款</b>：</div>
              <a-radio-group
                :disabled="disabled"
                :options="[
                  { value: 1, label: '默认勾选' },
                  { value: 2, label: '默认不勾选' }
                ]"
                v-model:value="integratedConfig.registerPrivacyPolicy"
              />
            </div>
            <div class="w500 mb20">
              <div class="mb4"><b>隐私条款文案</b>：</div>
              <quillEditor
                v-model:value="checkLangData.registerPrivacyPolicyText"
                style="height: 100px; width: 500px;"
                :options="editorOption"
              />
            </div>
            <div class="w500 mb20">
              <div class="mb4"><b>订阅</b>：</div>
              <a-radio-group
                :disabled="disabled"
                :options="[
                  { value: 1, label: '默认勾选' },
                  { value: 2, label: '默认不勾选' }
                ]"
                v-model:value="integratedConfig.registerSubscribeStatus"
              />
            </div>
            <div class="w500 mb20">
              <div class="mb4"><b>订阅文案</b>：</div>
              <quillEditor
                v-model:value="checkLangData.registerSubscribeText"
                style="height: 100px; width: 500px;"
                :options="editorOption"
              />
            </div>
          </div>
        </div>
      </div>
      <div v-show="tabType === 4">
        <Subscribe />
      </div>
      <div v-show="tabType === 5">
        <Sidebar />
      </div>
      <div v-show="tabType === 6">
        <subScribeComponent />
      </div>
      <div v-show="tabType === 7">
        <div class="df">
          <div>
            <div style="display: flex; flex-direction: row;">
              <div
                class="w300 mb20"
                style="display: flex; flex-direction: row;"
              >
                <div class="mb4"><b>pc端启用状态：</b></div>
                <a-switch
                  v-model:checked="integratedConfig.emailSubscribePcEnable"
                  checked-children="启用"
                  un-checked-children="禁用"
                  :checkedValue="1"
                  :unCheckedValue="0"
                  :disabled="disabled"
                />
              </div>
              <div
                class="w500 mb20"
                style="display: flex; flex-direction: row;"
              >
                <div class="mb4"><b>m端启用状态：</b></div>
                <a-switch
                  v-model:checked="integratedConfig.emailSubscribeMEnable"
                  checked-children="启用"
                  un-checked-children="禁用"
                  :checkedValue="1"
                  :unCheckedValue="0"
                  :disabled="disabled"
                />
              </div>
            </div>
            <div class="w500 mb20">
              <div class="mb4"><b>Email订阅-标题</b>：</div>
              <a-input
                :maxlength="500"
                placeholder="最多500个字符"
                v-model:value="checkLangData.emailSubscribeTitle"
                :class="{
                  'error-input':
                    !checkLangData.emailSubscribeTitle ||
                    checkLangData.emailSubscribeTitle.trim() === ''
                }"
              />
              <div
                v-if="
                  !checkLangData.emailSubscribeTitle ||
                    checkLangData.emailSubscribeTitle.trim() === ''
                "
                class="error-message"
                style="color: red; font-size: 12px; margin-top: 4px"
              >
                Email订阅-标题不能为空
              </div>
            </div>
            <div class="w500 mb20">
              <div class="mb4"><b>Email订阅-描述</b>：</div>
              <quillEditor
                v-model:value="checkLangData.emailSubscribeDescription"
                style="height: 100px; width: 500px;"
                :options="editorOption"
              />
              <div
                v-if="
                  !checkLangData.emailSubscribeDescription ||
                    checkLangData.emailSubscribeDescription
                      .replace(/<[^>]*>/g, '')
                      .replace(/&nbsp;/g, ' ')
                      .trim() === ''
                "
                class="error-message"
                style="color: red; font-size: 12px; margin-top: 4px"
              >
                Email订阅-描述不能为空
              </div>
            </div>
            <div class="w500 mb20">
              <div class="mb4"><b>Email订阅-按钮文案</b>：</div>
              <a-input
                :maxlength="500"
                placeholder="最多500个字符"
                v-model:value="checkLangData.emailSubscribeButtonText"
                :class="{
                  'error-input':
                    !checkLangData.emailSubscribeButtonText ||
                    checkLangData.emailSubscribeButtonText.trim() === ''
                }"
              />
              <div
                v-if="
                  !checkLangData.emailSubscribeButtonText ||
                    checkLangData.emailSubscribeButtonText.trim() === ''
                "
                class="error-message"
                style="color: red; font-size: 12px; margin-top: 4px"
              >
                Email订阅-按钮文案不能为空
              </div>
            </div>
            <div class="w500 mb20">
              <div class="mb4"><b>Email订阅-订阅成功描述</b>：</div>
              <quillEditor
                v-model:value="checkLangData.emailSubscribeSuccessDesc"
                style="height: 100px; width: 500px;"
                :options="editorOption"
              />
              <div
                v-if="
                  !checkLangData.emailSubscribeSuccessDesc ||
                    checkLangData.emailSubscribeSuccessDesc
                      .replace(/<[^>]*>/g, '')
                      .replace(/&nbsp;/g, ' ')
                      .trim() === ''
                "
                class="error-message"
                style="color: red; font-size: 12px; margin-top: 4px"
              >
                Email订阅-订阅成功描述不能为空
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  DeleteOutlined,
  EyeOutlined,
  PictureOutlined
} from '@ant-design/icons-vue'
import Sidebar from './Sidebar.vue'
import { quillEditor } from 'vue3-quill'
import { toRefs, reactive, inject } from 'vue'
import Subscribe from './Subscribe.vue'
import subScribeComponent from './subScribeComponent.vue'
export default {
  components: {
    quillEditor,
    PictureOutlined,
    DeleteOutlined,
    EyeOutlined,
    Subscribe,
    Sidebar,
    subScribeComponent
  },
  setup() {
    const state = reactive({
      subscribeKey: 1
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState')),
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      columns: [
        {
          title: 'Icon图片（22*22）',
          dataIndex: 'imgUrl',
          key: 'imgUrl',
          slots: { customRender: 'imgUrl' }
        },
        {
          title: 'URL',
          dataIndex: 'link',
          key: 'link',
          slots: { customRender: 'link' }
        },
        {
          title: '操作',
          dataIndex: 'deal',
          key: 'deal',
          slots: { customRender: 'deal' }
        }
      ],
      editorOption: {
        placeholder: '输入',
        modules: {
          toolbar: [
            [
              {
                font: [
                  'Muli-Light',
                  'Muli-SemiBold',
                  'Muli-Bold',
                  'Muli-ExtraBold'
                ]
              }
            ],
            [
              {
                size: [
                  '12px',
                  '14px',
                  '16px',
                  '18px',
                  '20px',
                  '22px',
                  '24px',
                  '26px',
                  '28px',
                  '30px',
                  '32px',
                  '34px',
                  '36px',
                  '38px',
                  '40px'
                ]
              }
            ],
            ['bold', 'link'],
            [
              {
                color: [
                  'red',
                  'blue',
                  'green',
                  'black',
                  'yellow',
                  'pink',
                  'white',
                  '#14AA6E'
                ]
              }
            ]
          ]
        }
      },
      statusOptions: [
        {
          label: '禁用',
          value: 0
        },
        {
          label: '启用',
          value: 1
        }
      ],
      alertFormOptions: [
        {
          label: '订阅弹窗',
          value: 1
        },
        {
          label: '注册弹窗',
          value: 2
        }
      ],
      alertTimesOptions: [
        {
          label: '是',
          value: true
        },
        {
          label: '否',
          value: false
        }
      ],
      triggerOptions: [
        {
          label: '所有用户（新访+老访）',
          value: 1
        },
        {
          label: '新用户（新访）',
          value: 2
        },
        {
          label: '未注册用户（新访+老访的未注册用户）',
          value: 3
        }
      ],
      sideTypeOptions: [
        {
          label: '文本',
          value: 1
        },
        {
          label: '图片',
          value: 2
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.subscription-left {
  margin-right: 50px;
  flex: 1;
}

.subscription-right {
  flex: 1;
}

.subscription-section {
  border-radius: 6px;
  margin-top: 20px;
}

.subscription-title {
  margin: 0 0 20px 0;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  padding-bottom: 10px;
}

.container-readOnly {
  .img-readonly {
    pointer-events: none;
  }
}
.editBread {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
}
.EditContainer {
  background: #ffffff;
  margin: 15px;
  padding: 15px 20px;
  .disabled,
  .pubilc.disabled,
  table.disabled {
    input,
    .sidebarContentBg,
    button {
      pointer-events: none;
      color: #aaa;
      background: #f5f5f5;
    }
  }
  .addMedia.disabled {
    pointer-events: none;
    color: #aaa;
    background: #f5f5f5;
  }
}
.checkTabs {
  width: 216px;
  height: 46px;
  background: #f0f0f0;
  display: flex;
  padding: 3px;
  border-radius: 3px;
}

.checkTab {
  width: 108px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  border-radius: 3px;
  cursor: pointer;
}

.checkTab.check {
  background: #ffffff;
}

.checkPicTabs {
  width: 146px;
  height: 36px;
  background: #f0f0f0;
  display: flex;
  padding: 3px;
  border-radius: 3px;
  margin: 0 auto 20px auto;
}

.checkPicTab {
  width: 70px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 3px;
  cursor: pointer;
}

.checkPicTab.check {
  background: #ffffff;
}

.EditContainerRight {
  background: #f4f4f4;
  width: 400px;
  padding: 14px;
  margin: 14px;
}

.sidebarContentBg .hover {
  width: 120px;
  height: 120px;
  display: none;
  cursor: pointer;
  color: #ffffff;
  text-align: center;
  line-height: 120px;
  background: rgba(0, 0, 0, 0.3);
}

.sidebarContentBg:hover .hover {
  display: block;
}

.addMedia {
  width: 100%;
  height: 40px;
  line-height: 40px;
  border: 1px dashed #cccccc;
  text-align: center;
  margin-top: 20px;
  font-size: 12px;
  cursor: pointer;
}
</style>
<style>
.sidebarTypeImg .ant-upload.ant-upload-drag .ant-upload {
  padding: 0;
}
</style>
